import ItemWrapper from 'components/Menu/MenuContentDesktop/styled/ItemWrapper';
import styled from 'styled-components';

export default styled(ItemWrapper)`
  color: transparent;
`;
